import React, { useEffect, useState, useRef } from 'react';
import { Upload, Globe, ChevronDown } from 'lucide-react';
export function Header() {
  const [language, setLanguage] = useState<'en' | 'ua'>('en');
  const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setLanguageDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return <header className="w-full bg-white py-4 px-6 md:px-12 sticky top-0 z-50 shadow-sm" data-id="element-163">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4" data-id="element-164">
        {/* Logo */}
        <a href="/" className="flex items-center flex-shrink-0" data-id="element-165">
          <img src="https://cdn.magicpatterns.com/uploads/4nkahh2hNsVZTnNq46Gbps/elvora_logo_cutout.png" alt="ELVORA" className="h-10 w-auto" data-id="element-166" />
        </a>

        {/* Center Navigation - Desktop */}
        <nav className="hidden lg:flex items-center justify-center gap-3 flex-1" data-id="element-167">
          <a href="/specialists" className="px-5 py-2 text-sm font-medium text-[var(--color-text-dark)] rounded-full border border-gray-200 hover:border-gray-300 transition-colors" data-id="element-168">
            For Seafarers
          </a>
          <a href="/companies" className="px-5 py-2 text-sm font-medium text-[var(--color-text-dark)] rounded-full border border-gray-200 hover:border-gray-300 transition-colors" data-id="element-169">
            For Companies
          </a>
        </nav>

        {/* Right side - Language + Upload */}
        <div className="flex items-center gap-3" data-id="element-170">
          {/* Language Dropdown - Desktop */}
          <div className="hidden md:block relative" ref={dropdownRef} data-id="element-171">
            <button onClick={() => setLanguageDropdownOpen(!languageDropdownOpen)} className="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-full hover:border-gray-300 transition-colors" data-id="element-172">
              <Globe className="w-4 h-4 text-gray-500" data-id="element-173" />
              <span className="text-sm font-medium text-[var(--color-text-dark)]" data-id="element-174">
                {language === 'en' ? 'EN' : 'UA'}
              </span>
              <ChevronDown className="w-4 h-4 text-gray-500" data-id="element-175" />
            </button>

            {languageDropdownOpen && <div className="absolute top-full right-0 mt-2 w-32 bg-white border border-gray-200 rounded-lg shadow-lg overflow-hidden" data-id="element-176">
                <button onClick={() => {
              setLanguage('en');
              setLanguageDropdownOpen(false);
            }} className={`w-full px-4 py-2 text-left text-sm hover:bg-gray-50 transition-colors ${language === 'en' ? 'bg-[var(--color-tan)]/10 text-[var(--color-tan)] font-medium' : 'text-[var(--color-text-dark)]'}`} data-id="element-177">
                  English
                </button>
                <button onClick={() => {
              setLanguage('ua');
              setLanguageDropdownOpen(false);
            }} className={`w-full px-4 py-2 text-left text-sm hover:bg-gray-50 transition-colors ${language === 'ua' ? 'bg-[var(--color-tan)]/10 text-[var(--color-tan)] font-medium' : 'text-[var(--color-text-dark)]'}`} data-id="element-178">
                  Українська
                </button>
              </div>}
          </div>

          {/* Upload Resume Button - Desktop */}
          <a href="/specialists" className="hidden md:flex items-center gap-2 px-5 py-2.5 bg-[var(--color-tan)] text-white text-sm font-medium rounded-full hover:opacity-90 transition-opacity" data-id="element-179">
            <Upload className="w-4 h-4" data-id="element-180" />
            <span className="hidden lg:inline" data-id="element-181">Send CV</span>
          </a>

          {/* Mobile - Language + Send Resume */}
          <div className="flex md:hidden items-center gap-2" data-id="element-182">
            <button className="p-2.5 border border-gray-200 rounded-full hover:border-gray-300 transition-colors" data-id="element-183">
              <Globe className="w-5 h-5 text-gray-500" data-id="element-184" />
            </button>
            <a href="/specialists" className="flex items-center gap-2 px-4 py-2.5 bg-[var(--color-tan)] text-white text-sm font-medium rounded-full hover:opacity-90 transition-opacity" data-id="element-185">
              <Upload className="w-4 h-4" data-id="element-186" />
              <span data-id="element-187">Send CV</span>
            </a>
          </div>

          {/* Mobile menu button */}
          <button className="lg:hidden p-2" aria-label="Menu" data-id="element-188">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-189">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" data-id="element-190" />
            </svg>
          </button>
        </div>
      </div>
    </header>;
}